import React from 'react';

import { TabelaFilaInstrumentos } from '../../components/TabelaFilaInstrumentos';
import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';

export default function InscricoesPage() {

  return (
    <>
      <MenuMain >
        <TabelaFilaInstrumentos />
      </MenuMain>
      <AppFooter />
    </>
  );
}
